import { useCallback, useRef } from "react";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { TEntityInfo } from "../../../../common/types/utility";
import { TMenuIds } from "../types";
import { updateMenu } from "../slice";

export const useAppMenus = () => {
  const dispatch = useAppDispatch();
  const anchorRef = useRef<HTMLElement | null>(null);
  const openMenuId = useRef<TMenuIds | null>(null);

  const resolveElement = (
    source: React.MouseEvent | HTMLElement,
  ): HTMLElement => {
    if (source instanceof HTMLElement) {
      return source;
    }
    return source.currentTarget as HTMLElement;
  };

  const handleOpenMenu = useCallback(
    (
      event: React.MouseEvent | HTMLElement,
      menuId: TMenuIds,
      info: TEntityInfo | null,
      subtype?: string,
    ) => {
      const button = resolveElement(event);
      anchorRef.current = button;
      openMenuId.current = menuId;

      const rect = button.getBoundingClientRect();
      dispatch(
        updateMenu({
          id: menuId,
          info: info,
          isOpen: true,
          position: { x: rect.x, y: rect.y },
          subtype,
          parentId: undefined,
        }),
      );
    },
    [dispatch],
  );

  const handleOpenSubMenu = useCallback(
    (
      event: React.MouseEvent,
      childId: TMenuIds,
      parentId: TMenuIds,
      subtype?: string,
    ) => {
      const element = event.currentTarget as HTMLElement;
      const rect = element.getBoundingClientRect();

      dispatch(
        updateMenu({
          id: childId,
          isOpen: true,
          parentId,
          subtype,
          position: {
            x: Number(`${rect.right - 34}`),
            y: rect.top,
          },
        }),
      );
    },
    [dispatch],
  );

  const handleCloseMenu = useCallback(
    (menuId: TMenuIds, subtype?: string) => {
      dispatch(
        updateMenu({
          id: menuId,
          info: null,
          isOpen: false,
          position: null,
        }),
      );
    },
    [dispatch],
  );

  return {
    handleOpenMenu,
    handleCloseMenu,
    handleOpenSubMenu,
  };
};
